// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JKpu","questions":"styles_questions__1KEs-","footer":"styles_footer__2qb4q"};